import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailDocumentFmea } from '../dto/trail-document-fmea';

@Injectable({
  providedIn: 'root'
})
export class TrailDocumentFmeaService {

  private apiUrl = environment.apiRoot + '/trialdocufmea';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(trialId: number): Observable<TrailDocumentFmea[]> {
    return this.http.get<TrailDocumentFmea[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createDocumentFmea(trialId: number): Observable<TrailDocumentFmea> {
    let model = { "id": 0, "trial_id": trialId, "fmea_report": "new fmea report" };
    return this.http.post<TrailDocumentFmea>(this.apiUrl + '/new', model);
  }

  updateDocumentFmea(model: TrailDocumentFmea): Observable<TrailDocumentFmea> {
    return this.http.put<TrailDocumentFmea>(this.apiUrl + '/update', model);
  }

  deleteDocumentFmea(trialDocumentFmeaId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialDocuFmealId=' + trialDocumentFmeaId);
  }
}
